import { Box } from "@mui/material";
import RegisterCallersFormWithLabel from "../../components/register-callers-form-label/RegisterCallersForm";

export default function RegisterUserWithLabel() {
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "var(--bg-page)",
        padding: "100px",
      }}
    >
      <RegisterCallersFormWithLabel />
    </Box>
  );
}
